/**
 * Created by Victor Rojo on 18/2/20.
 */
export class SurveillanceCamera{
  constructor(
    public cameraId: string,
    public iPlaceId: string,
    public iPlaceName: string,
    public name: string,
    public rows: number,
    public columns: number
){}
}
